/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { GameModelDto } from '../models/game-model-dto';
import { PlayByPlayModelGameDto } from '../models/play-by-play-model-game-dto';
import { scoutingControllerExternalEventsBulkPresignedUrls } from '../fn/external-scouting/scouting-controller-external-events-bulk-presigned-urls';
import { ScoutingControllerExternalEventsBulkPresignedUrls$Params } from '../fn/external-scouting/scouting-controller-external-events-bulk-presigned-urls';
import { scoutingControllerGetEventsWithVideoExternal } from '../fn/external-scouting/scouting-controller-get-events-with-video-external';
import { ScoutingControllerGetEventsWithVideoExternal$Params } from '../fn/external-scouting/scouting-controller-get-events-with-video-external';
import { scoutingControllerGetTeamGamesWithVideoExternal } from '../fn/external-scouting/scouting-controller-get-team-games-with-video-external';
import { ScoutingControllerGetTeamGamesWithVideoExternal$Params } from '../fn/external-scouting/scouting-controller-get-team-games-with-video-external';
import { scoutingControllerGetTeamsWithVideoExternal } from '../fn/external-scouting/scouting-controller-get-teams-with-video-external';
import { ScoutingControllerGetTeamsWithVideoExternal$Params } from '../fn/external-scouting/scouting-controller-get-teams-with-video-external';
import { TeamWithVideoDto } from '../models/team-with-video-dto';

@Injectable({ providedIn: 'root' })
export class ExternalScoutingService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `scoutingControllerGetTeamsWithVideoExternal()` */
  static readonly ScoutingControllerGetTeamsWithVideoExternalPath = '/scouting/external/teams';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scoutingControllerGetTeamsWithVideoExternal()` instead.
   *
   * This method doesn't expect any request body.
   */
  scoutingControllerGetTeamsWithVideoExternal$Response(params?: ScoutingControllerGetTeamsWithVideoExternal$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TeamWithVideoDto>>> {
    return scoutingControllerGetTeamsWithVideoExternal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scoutingControllerGetTeamsWithVideoExternal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scoutingControllerGetTeamsWithVideoExternal(params?: ScoutingControllerGetTeamsWithVideoExternal$Params, context?: HttpContext): Observable<Array<TeamWithVideoDto>> {
    return this.scoutingControllerGetTeamsWithVideoExternal$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TeamWithVideoDto>>): Array<TeamWithVideoDto> => r.body)
    );
  }

  /** Path part for operation `scoutingControllerGetTeamGamesWithVideoExternal()` */
  static readonly ScoutingControllerGetTeamGamesWithVideoExternalPath = '/scouting/external/{teamUuid}/games';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scoutingControllerGetTeamGamesWithVideoExternal()` instead.
   *
   * This method doesn't expect any request body.
   */
  scoutingControllerGetTeamGamesWithVideoExternal$Response(params: ScoutingControllerGetTeamGamesWithVideoExternal$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GameModelDto>>> {
    return scoutingControllerGetTeamGamesWithVideoExternal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scoutingControllerGetTeamGamesWithVideoExternal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  scoutingControllerGetTeamGamesWithVideoExternal(params: ScoutingControllerGetTeamGamesWithVideoExternal$Params, context?: HttpContext): Observable<Array<GameModelDto>> {
    return this.scoutingControllerGetTeamGamesWithVideoExternal$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GameModelDto>>): Array<GameModelDto> => r.body)
    );
  }

  /** Path part for operation `scoutingControllerGetEventsWithVideoExternal()` */
  static readonly ScoutingControllerGetEventsWithVideoExternalPath = '/scouting/external/events';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scoutingControllerGetEventsWithVideoExternal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scoutingControllerGetEventsWithVideoExternal$Response(params: ScoutingControllerGetEventsWithVideoExternal$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayByPlayModelGameDto>>> {
    return scoutingControllerGetEventsWithVideoExternal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scoutingControllerGetEventsWithVideoExternal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scoutingControllerGetEventsWithVideoExternal(params: ScoutingControllerGetEventsWithVideoExternal$Params, context?: HttpContext): Observable<Array<PlayByPlayModelGameDto>> {
    return this.scoutingControllerGetEventsWithVideoExternal$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlayByPlayModelGameDto>>): Array<PlayByPlayModelGameDto> => r.body)
    );
  }

  /** Path part for operation `scoutingControllerExternalEventsBulkPresignedUrls()` */
  static readonly ScoutingControllerExternalEventsBulkPresignedUrlsPath = '/scouting/external/events/bulk/presigned-urls';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `scoutingControllerExternalEventsBulkPresignedUrls()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scoutingControllerExternalEventsBulkPresignedUrls$Response(params: ScoutingControllerExternalEventsBulkPresignedUrls$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PlayByPlayModelGameDto>>> {
    return scoutingControllerExternalEventsBulkPresignedUrls(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `scoutingControllerExternalEventsBulkPresignedUrls$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  scoutingControllerExternalEventsBulkPresignedUrls(params: ScoutingControllerExternalEventsBulkPresignedUrls$Params, context?: HttpContext): Observable<Array<PlayByPlayModelGameDto>> {
    return this.scoutingControllerExternalEventsBulkPresignedUrls$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PlayByPlayModelGameDto>>): Array<PlayByPlayModelGameDto> => r.body)
    );
  }

}
